import { useState, useEffect } from 'react';

const useLocation = () => {
	const [location, setLocation] = useState('');

	useEffect(() => {
		const storedLocation = localStorage.getItem('location');
		if (storedLocation) {
			setLocation(storedLocation);
		}
	}, []);

	return location;
};

export default useLocation;
